
const meta = {
  loadState: true,
  auth: true,
  isAuthPage: false,
  permissions: [
    {
      subject: 'clicky-advertisers',
      actions: ['list-all']
    }
  ],
}

export default [
  {
    path: '/tracking-management',
    component: () => import('../../views/Proxy.vue'),
    meta,
    children: [
      {
        path: '',
        name: 'tracking-management',
        meta,
        component: () => import('../../views/tracking/Index.vue'),
        children: [
          {
            path: 'new-advertiser',
            name: 'tracking-management-new-advertiser',
            meta,
            component: () => import('../../views/tracking/AddNewAdvertiser.vue'),
          },
          {
            path: 'bulk-upload',
            name: 'tracking-management-bulk-upload',
            meta,
            component: () => import('../../views/tracking/BulkUpload.vue'),
          },
        ]
      },
      {
        path: 'advertiser/:id(\\d+)',
        name: 'tracking-management-advertiser',
        meta,
        component: () => import('../../views/tracking/Advertiser.vue'),
        children: [
          {
            path: 'new-program',
            name: 'tracking-management-advertiser-program-new',
            meta,
            component: () => import('../../views/tracking/AddNewProgram.vue'),
          },
          {
            path: 'program/:programId(\\d+)',
            name: 'tracking-management-advertiser-program-details',
            meta,
            component: () => import('../../views/tracking/EditProgram.vue'),
          },
          {
            path: 'delete-domain/:domainId(\\d+)',
            name: 'tracking-management-advertiser-domain-delete',
            meta,
            component: () => import('../../views/tracking/DeleteDomain.vue'),
          },
        ]
      },
    ]
  },
  {
    path: '/tracking-networks',
    component: () => import('../../views/Proxy.vue'),
    meta,
    children: [
      {
        path: '',
        name: 'tracking-networks',
        meta,
        component: () => import('../../views/tracking/Networks.vue'),
        children: [
          {
            path: 'new-network',
            name: 'tracking-networks-new',
            meta,
            component: () => import('../../views/tracking/NewNetwork.vue'),
          },
        ],
      },
      {
        path: 'network/:id(\\d+)',
        name: 'tracking-networks-detail',
        meta,
        component: () => import('../../views/tracking/Network.vue'),
        children: [
          {
            path: 'new-credentials',
            name: 'tracking-networks-new-credentials',
            meta,
            component: () => import('../../views/tracking/Credentials.vue'),
          },
          {
            path: 'credential/:credentialId(\\d+)',
            name: 'tracking-networks-edit-credentials',
            meta,
            component: () => import('../../views/tracking/EditCredentials.vue'),
          },
        ],
      },
    ],
  },
];
